import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useOry } from '@apps/web/hooks/ory';
import { dispatchSessionEnded } from '@apps/web/lib/event_bus';
import { getRuntimeConfig } from '@apps/web/lib/runtime_config';

export const Route = createFileRoute('/_auth/sign-out')({
    component: SignOutPage,
});

function SignOutPage() {
    const { oryClient, normalizeOryPayload } = useOry();
    const { apiUrl } = getRuntimeConfig();

    useEffect(() => {
        (async () => {
            void fetch(`${apiUrl}/users/me/logout`, {
                method: 'POST',
                credentials: 'include',
                keepalive: true,
            }).catch(() => {
                // best-effort cache eviction before completing logout
            });

            let nextUrl = '/sign-in';
            try {
                const { logout_token, logout_url } = normalizeOryPayload(
                    await oryClient.createBrowserLogoutFlow(),
                );
                nextUrl = logout_url;
                await oryClient.updateLogoutFlow({
                    token: logout_token,
                });
                nextUrl = '/sign-in';
            } catch {
                console.error('Failed to logout');
            }
            dispatchSessionEnded('logout');
            window.location.replace(nextUrl);
        })();
    }, [apiUrl, normalizeOryPayload, oryClient]);

    return null;
}
